import { render } from "./MyRestaurantChecks.vue?vue&type=template&id=0a073aae&scoped=true"
import script from "./MyRestaurantChecks.vue?vue&type=script&lang=js"
export * from "./MyRestaurantChecks.vue?vue&type=script&lang=js"

import "./MyRestaurantChecks.vue?vue&type=style&index=0&id=0a073aae&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a073aae"]])

export default __exports__